import { FormattedMessage } from 'react-intl'

import noChart from '@static/images/dashboards/no-data_chart.png'
import './EmptyChartState.css'

export default function EmptyChartState() {
  return (
    <div className="widget-view widget-view-empty">
      <div className="wrapper">
        <img src={noChart} alt="" />
        <h4>
          <FormattedMessage id="widget-view.empty.title" />
        </h4>
      </div>
    </div>
  )
}
